// Define the action types as constants

// Define the productnamereducer to handle the SET_PRODUCT_NAME action
 const productnamereducer = (state = true, action) => {
    switch (action.type) {
      case "SET_PRODUCT_NAME":
        return !state; // Toggle the boolean value
      default:
        return state;
    }
  };

  export default productnamereducer;